module.exports = __webpack_public_path__ + "static/media/facebookIcon.3ae13bc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/facebookIcon.svg
// module id = 91
// module chunks = 0